import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/**
 * Hook that defers updating a value until fetching is complete.
 * Useful for preventing UI flickering during refetches by keeping the
 * previous value visible until the new fetch completes.
 *
 * @param value - The value to track
 * @param isFetching - Whether a fetch operation is in progress
 * @returns The memoized value that only updates when isFetching becomes false
 */
export function useChangeAfterFetching(value, isFetching) {
  const $ = _c(4);
  const [memoizedValue, setMemoizedValue] = useState(value);
  let t0;
  let t1;
  if ($[0] !== isFetching || $[1] !== value) {
    t0 = () => {
      if (!isFetching) {
        setMemoizedValue(value);
      }
    };
    t1 = [value, isFetching];
    $[0] = isFetching;
    $[1] = value;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return memoizedValue;
}